try {
    
    // Framework UIkit
    window.UIkit = require('uikit');
    let Icons = require('uikit/dist/js/uikit-icons');
    UIkit.use(Icons);
    
    /**
     * Libreria para crear un datepicker
     * 
     * https://pikaday.com
     */
    window.Pikaday = require('pikaday/pikaday');
    
    /**
     * Libreria para selects con buscador y selects multiples
     * aparte de añadir nuevos elementos.
     *
     * http://slimselectjs.com/
     */
    window.SlimSelect = require('slim-select');

    /**
     * Libreria para validaciones
     *
     * https://validatejs.org/
     */
    
    //  Dependencia para fechas
    // require( 'moment' );

    window.validate = require("validate.js");

    // Components
    require('./components/showdate');
    require('./components/slide-form');
    require('./components/validate_complaints');
    require('./components/validate_nonconformities');
	
} catch (e) {}
